import { Component, OnInit } from '@angular/core';
import { AlertComponent } from 'app/popup/alert.component';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { DialogService } from 'ng2-bootstrap-modal';
import { ActivatedRoute, Router } from '@angular/router';
import { VehicleMakeService } from 'app/services/vehicle-make.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vehicle-make',
  templateUrl: './vehicle-make.component.html',
  styleUrls: ['./vehicle-make.component.css']
})
export class VehicleMakeComponent implements OnInit {

  form;
  vMake: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;  
  isDup = false;  
  selectedGroupCode: any = {};
  selectedDisplay = 3;
  message = null;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  
  public isLoading = false;

  constructor(private service: VehicleMakeService, private authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,
     public utility: UtilityServiceService,private toastr:ToastrService) { }

  ngOnInit() {

    this.initForm();    
    this.onChanges();
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.sub = this.route.params.subscribe(params => {
      if (this.router.url.indexOf('edit') != -1) {
        this.isEdit = true;
        this.lblHeading = 'Edit Vehicle Make';
        this.btnActionLabel = 'Update';
        const id = +params['id'];
        this.isLoading = true;
        this.service.getById(id).subscribe(result => {
          this.vMake = result;
          this.isLoading = false;
          (<UntypedFormGroup>this.form)
            .setValue({
              id: this.vMake.id
              , code: this.vMake.code
              , description: this.vMake.description
              , group_code: this.vMake.group_code
              , sort_order: this.vMake.sort_order
              , is_active: this.vMake.is_active
              , display_ind: this.vMake.display_ind
              , date_created: this.vMake.date_created
              , date_modified: this.vMake.date_modified
              , user_created: this.vMake.user_created
              , user_modified: this.vMake.user_modified
              , vehicle: (this.vMake.vehicle) ? this.vMake.vehicle:null
            }, { onlySelf: true });
          this.audit = this.utility.setAuditAttributes(this.vMake.date_created, this.vMake.user_created, this.vMake.date_modified, this.vMake.user_modified);
        });
      } else {
        this.isEdit = false;
        this.lblHeading = 'New Vehicle Make';
        this.btnActionLabel = 'Save';
        this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName); 
      }


    });
  }


  initForm() {
    this.form = new UntypedFormGroup({
      id: new UntypedFormControl()
      , code: new UntypedFormControl(this.vMake.code, Validators.compose([Validators.required, <any>Validators.maxLength(12), Validators.pattern('[\\w\-\\s\\/]+')]))
      , description: new UntypedFormControl(this.vMake.description, Validators.maxLength(100))
      , group_code: new UntypedFormControl(this.vMake.group_code, Validators.compose([Validators.required, <any>Validators.maxLength(12)]))
      , sort_order: new UntypedFormControl(this.vMake.sort_code)
      , is_active: new UntypedFormControl()
      , display_ind: new UntypedFormControl(this.vMake.display_ind)
      , date_created: new UntypedFormControl()
      , date_modified: new UntypedFormControl()
      , user_created: new UntypedFormControl()
      , user_modified: new UntypedFormControl()
      , vehicle: new UntypedFormControl()
    });
    this.form.patchValue(this.utility.defaults);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(obj: any) {
    if (this.isDup) { return; }
    this.vMake = obj;
    this.message = (this.isEdit) ? "Updating Vehicle make..." : "Adding a new Vehicle Make...";
    if (this.isEdit) {
      this.vMake.date_modified = new Date().toLocaleString();
      this.vMake.user_modified = this.user.LastName;
      this.isLoading = true;
      //console.log(JSON.stringify(obj));
      this.service.update(this.vMake).subscribe(result => {
        this.vMake = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Update Vehicle Make', message: `Vehicle Make ${this.vMake.code} updated succesfully.`, bold: `${this.vMake.code}` });
        this.toastr.success(`Vehicle Make ${this.vMake.code} updated succesfully.`,'Update Vehicle Make');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: `Update Vehicle Make`, message: `Failed to update Vehicle Make with ${this.vMake.code}.Please contact the system administrator if the problem persists.`, bold: `${this.vMake.code}` });
        this.toastr.error(`Failed to update Vehicle Make with ${this.vMake.code}.Please contact the system administrator if the problem persists.`,'Update Vehicle Make');
      });
    } else {
      this.vMake.date_modified = this.vMake.date_created = new Date().toLocaleString();
      this.vMake.user_modified = this.vMake.user_created = this.user.LastName;

      this.isLoading = true;     
      this.service.add(this.vMake).subscribe(result => {
        this.vMake = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Vehicle Make', message: `New Vehicle Make ${this.vMake.code} added successfully.`, bold: `${this.vMake.code}` });
        this.toastr.success(`New Vehicle Make ${this.vMake.code} added successfully.`,'New Vehicle Make');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: `New Vehicle Make`, message: `Failed to add New Vehicle Make with ${this.vMake.code}.Please contact the system administrator if the problem persists.`, bold: `${this.vMake.code}` });
        this.toastr.error(`Failed to add New Vehicle Make with ${this.vMake.code}.Please contact the system administrator if the problem persists.`,'New Vehicle Make');

      });
    }
  }

  navigate() {
    this.router.navigateByUrl('/vehicle/make/list');
  }

  onDuplicates(control) {


  }

  onChanges(): void {
    this.form.get('code').valueChanges.subscribe(code => {

      if (code.length > 3) {
        this.service.checkByCode(code.trim()).subscribe((result:any) => {
          this.isDup = (result.Status && !this.isEdit) ? true : false;
        }, error => {
          this.isDup = false;

        });
      }
    });
  }



  onChangeValue() {
    
  }

  onSelectChange() {
    console.dir(this.selectedDisplay);
  }



}
